import React from "react";
import PageTitle from "../Contract/PageTitle";

export default function HomePageTitle() {
  return <PageTitle period />;
}
